import React, { useEffect } from "react";
import { Box, BoxProps, Typography } from "@mui/material";
import { ADSENSE_PUBLISHER_ID } from "../../config/adsense";

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export interface AdSenseProps extends Omit<BoxProps, "component"> {
  adSlot: string;
  adFormat?: string;           // "auto" or "fluid"
  adLayoutKey?: string;        // required for fluid ads
  fullWidthResponsive?: boolean;
}

export const AdSense: React.FC<AdSenseProps> = ({
  adSlot,
  adFormat = "auto",
  adLayoutKey,
  fullWidthResponsive = true,
  sx,
  ...boxProps
}) => {
  useEffect(() => {
    try {
      if (!window.adsbygoogle) window.adsbygoogle = [];
      window.adsbygoogle.push({});
    } catch (e) {
      console.error("Adsense error:", e);
    }
  }, []);

  // Show placeholder in development mode
  if (process.env.NODE_ENV !== "production") {
    return (
      <Box
        {...boxProps}
        sx={{
          minHeight: 120,
          bgcolor: "#374158",
          border: "1px dashed #aaa",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...sx,
        }}
      >
        AdSense Placeholder ({adSlot})
      </Box>
    );
  }

  return (
    <Box {...boxProps} sx={{

        border: "1px dashed #aaa",
        ...sx}}>
      <Typography variant="body1" sx={{         
        mt: 2,
        ml: 2,
        mb: 2, }}>Sponsored</Typography>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_PUBLISHER_ID}
        data-ad-slot={adSlot}
        data-ad-format={adFormat}
        data-full-width-responsive={fullWidthResponsive ? "true" : undefined}
        {...(adLayoutKey && { "data-ad-layout-key": adLayoutKey })}
      />
    </Box>
  );
};

export default AdSense;
